<template>
  <div class="introduce_unit">
    <h2 class="title">
      <span>合作机构 - </span>
    </h2>
    <div>
      <ul class="unit_picture">
        <li v-for="(item, index) in unit_source" :key="index">
          <img :src="item.unit_picture" alt=""/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { onMounted } from 'vue';
import { partners } from '@/api/partner';
import { conformsTo } from 'lodash';
export default {
  name: 'introduceUnit',
  components: {},
  props: {},
  data() {
    return {
      counttoflag: true,
      unit_source: [
        {
          unit_picture: require('../../../assets/images/sx_unit.png'),
        },
        {
          unit_picture: require('../../../assets/images/yl_logo.png'),
        },
        {
          unit_picture: require('../../../assets/images/gr_unit.png'),
        },
      ],
    };
  },
  watch: {},
  computed: {},
  // methods: { async getPartners() {
  //       this.unit_source = (await partners()).data || [];
  //     },

  // },
  created() { 
   console.log("6776666")
    console.log("6776666")
   this.getPartners()
 
  console.log(this.unit_source)
},
  mounted() { },

};
</script>
<style lang="less" scoped>
.introduce_unit {
  width: 100%;
  background: #fff;
  min-width: 1400px;
  height: 300px;
  padding: 40px 0 0 0;
  margin: 0 auto;
}

.introduce_unit div {
  width: 100%;
  background: #f8f8f8;
}

.introduce_unit .title {
  display: flex;
  align-items: center;
  width: 1200px;
  margin: 0 auto;
  padding: 0 0 20px 10px;
}

.introduce_unit .title span {
  display: inline-block;
  color: #121313;
  font: normal 20px Microsoft YaHei;
}

.unit_picture {
  display: flex;
  align-items: center;
  width: 1200px;
  margin: 0 auto;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 10px;
  padding: 5px 0;
  justify-content: flex-start;
}

.unit_picture li {
  width: 241px;
  height: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 12px;
  padding: 8px;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}

.unit_picture li img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  cursor: pointer;
  object-fit: contain;
}
</style>
